import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router-dom';
import PAGES, { PAGE_LIST } from "../pages";
import PrivateRoute from "./PrivateRoute";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {
        PAGES.map((page) => {
          return page.privateRoute ? null : <Route path={page.path} element={page.component} key={page.name} />
        })
      }
      <Route element={<PrivateRoute />}>
        {
          PAGES.map((page) => {
            return page.privateRoute ? <Route path={page.path} element={page.component} key={page.name} /> : null
          })
        }
      </Route>
      <Route
        path="*"
        element={<Navigate to={PAGE_LIST.APPROVAL} replace />}
      />
    </>
  )
)

export default router;